import * as React from "react";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { DecorateEditorialHtml } from "../../../ContentUtilities";
import { UitkText } from "uitk-react-text";
import { EditorialModel } from "src/typings/microserviceModels/content-flex-module";
import { UitkSpacing } from "uitk-react-spacing";

const CONTENT_ID_COUNT = 6;
export const CardComparisonFeatureSectionEditorial = (props: { items: EditorialModel[] }) => {
  const { items } = props;

  if (items.length !== CONTENT_ID_COUNT) {
    return null;
  }

  const [
    cardStatusFeatureOneIcon,
    cardStatusFeatureOneDescription,
    cardStatusFeatureTwoIcon,
    cardStatusFeatureTwoDescription,
    cardStatusFeatureThreeIcon,
    cardStatusFeatureThreeDescription,
  ] = React.useMemo(() => items.map((item) => <DecorateEditorialHtml key={item.id} text={item.text} />), []);

  return (
    <div className="uitk-type-center">
      <UitkLayoutGrid columns={12} space="six">
        <UitkSpacing padding={{ blockend: "two" }}>
          <UitkLayoutGridItem colSpan={4}>
            <div>
              {cardStatusFeatureOneIcon}
              <UitkSpacing padding={{ blockstart: "one", blockend: "six" }}>
                <UitkText align="center" size={200} weight="medium">
                  {cardStatusFeatureOneDescription}
                </UitkText>
              </UitkSpacing>
            </div>
          </UitkLayoutGridItem>
        </UitkSpacing>

        <UitkLayoutGridItem colSpan={4}>
          <div>
            {cardStatusFeatureTwoIcon}
            <UitkSpacing padding={{ blockstart: "one", blockend: "half" }}>
              <UitkText align="center" size={200} weight="medium">
                {cardStatusFeatureTwoDescription}
              </UitkText>
            </UitkSpacing>
          </div>
        </UitkLayoutGridItem>

        <UitkSpacing padding={{ blockend: "two" }}>
          <UitkLayoutGridItem colSpan={4}>
            <div>
              {cardStatusFeatureThreeIcon}
              <UitkSpacing padding={{ blockstart: "one", blockend: "six" }}>
                <UitkText align="center" size={200} weight="medium">
                  {cardStatusFeatureThreeDescription}
                </UitkText>
              </UitkSpacing>
            </div>
          </UitkLayoutGridItem>
        </UitkSpacing>
      </UitkLayoutGrid>
    </div>
  );
};

export default CardComparisonFeatureSectionEditorial;
